// Información de build generada automáticamente
export const BUILD_DATE = '25-03-2026 18:44:44';
export const BUILD_HASH = 'mq7rwrsp53b';
export const APP_VERSION = '0.0.0';
export const BUILD_TIMESTAMP = 1774475084040;

// Para debugging en consola
console.log('%cℹ️ Build Info', 'color: #2196F3; font-weight: bold;', {
  buildDate: '25-03-2026 18:44:44',
  buildHash: 'mq7rwrsp53b',
  appVersion: '0.0.0',
  timestamp: 1774475084040
});
